import { BackendResponse } from "../BackendResponse";
import { NextApiParams, withNextApi } from "../nextApiHelpers";

export interface GetCachedQuickApplyParametersResponse extends BackendResponse {
  item: CachedQuickApplyParameters;
}

export interface GetCachedQuickApplyParameters extends NextApiParams {
  cvpqap: string;
}

export const getCachedQuickApplyParameters = withNextApi<
  GetCachedQuickApplyParametersResponse,
  GetCachedQuickApplyParameters
>("/auth/GetCachedQuickApplyParameters", { method: "GET" });

export interface CachedQuickApplyParameters {
  tryAutoAttachProfileWithConnectEmail: boolean;
  tryUseAlreadyConnectedProfile: boolean;
  detachProfileBeforeApplying: boolean;
  vc_Name: string;
  vc_FirstName: string;
  vc_LastName: string;
  vc_Email: string;
  vc_EmailConfirmed: boolean;
  vc_PhoneNumber: string;
  vc_PhoneConfirmed: boolean;
  consent: boolean;
  concernId: number;
  relatedId: number;
  relatedType: number;
}
